import { RootState } from "@react-three/fiber";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// --- 1. State Interface ---
interface ProductState {
  defaultProduct: {
    _id: string;
    name: string;
    image?: string;
    // Add other fields if needed
  } | null;
}

const initialState: ProductState = {
  defaultProduct: null,
};

// --- 2. Slice Definition ---
export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // Action to save the master product type
    setDefaultProduct: (state, action: PayloadAction<any>) => {
      state.defaultProduct = action.payload;
    },
    // Optional: Clear it if needed (e.g. on logout)
    clearProductState: (state) => {
      state.defaultProduct = null;
    },
  },
});

// --- 3. Actions ---
export const { setDefaultProduct, clearProductState } = productSlice.actions;

// --- 4. Selectors (Helpers) ---

// Get the full object
export const selectDefaultProduct = (state: { product: ProductState }) =>
  state.product.defaultProduct;

// ✅ Helper: Get ONLY the ID (Safe Access)
// Usage: const defaultId = useSelector(selectDefaultProductId);
export const selectDefaultProductId = (state: { product: ProductState }) =>
  state.product.defaultProduct?._id;

// --- 5. Reducer Export ---
export default productSlice.reducer;
